export default "__VITE_ASSET__DY2Hqjgz__"